<template>
    <div class="qr-code-container">
        <div class="qr-code-name">{{ qrCodeName }}</div>
        <img :src="qrCodeUrl" class="qr-code-image" alt="二维码图片">
        <div class="tips-container">
            <p class="tip-text">长按识别二维码，关注公众号，开始服务</p>
            <p class="tip-text">首次登录，需点击右下角“使用完整服务”</p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                qrCodeName: "眼健康在线运营中心", // 这里可以根据实际情况修改二维码名字
                qrCodeUrl: "https://test.yjkok.com/eye/gh_4a17fef3e06a.jpg" // 请替换为真实的二维码图片地址
            };
        },

        mounted() {
            let type = this.$route.query.type;
            if (type == 1) {
                this.qrCodeName = "眼健康在线"; 
                this.qrCodeUrl = "https://i.yjkok.com/eye/gh_3ca9b0d5da76.jpg"
            }
            //调用接口存入缓存，这里应该存小程序的unid，而不是openid
            let hospitalId = this.$route.query.hospitalId;
            this.$http.post(this.$url.saveOpenRecord, { unionid: this.$route.query.unionid,
                hospitalId: hospitalId
            }).then(res => {
                if (res.code == 200) {
                    console.log("存入缓存成功")
                } else {
                    console.log("存入缓存失败")
                }
            })
        }
    };

</script>


<style scoped>
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.qr-code-name {
  font-size: 18px;
  margin-bottom: 10px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.tips-container {
  margin-top: 20px;
  text-align: center; /* 使内部文本居中 */
}

.tip-text {
  font-size: 14px; /* 设置文本大小 */
  margin: 0; /* 去除默认的外边距 */
  line-height: 1.5; /* 设置行高 */
  font-weight: bold; /* 添加字体加粗样式 */
}
</style>